
var shiftsCalendarPlanner;

var shiftsCalendarLastSelectedHasSelected;
var shiftsCalendarLastSelectedStartTime;
var shiftsCalendarLastSelectedEndTime;

var shiftsCalendarIsWaitingForGuardSelection;

var shiftsCalendarAllGuards;

var calendarHolder = [null, null, null, null, null];

var eventCreateCurrentlySelectedMode = 0;
var eventCreateCurrentlySelectedTab = 1;

var eventCreateCurrentlyRegisteredOrFillerGuardSelectedMode = 0;

var guardsShiftsCacheForFilter = null;
var guardsShiftsFilterIsActive = false;

function CreatePlannerScheduler(calendarNumber, calendarElement, dateFormat, localTime) {

    $(document).ready(function () {

        $('#external-events-' + calendarNumber + ' .fc-event').each(function () {

            // store data so the calendar knows to render an event upon drop
            $(this).data('event', {
                title: $.trim($(this).text()), // use the element's text as the event title
                stick: true, // maintain when user navigates (see docs on the renderEvent method)
                color: $(this).data('color')
            });

            // make the event draggable using jQuery UI
            $(this).draggable({
                zIndex: 999,
                revert: true,      // will cause the event to go back to its
                revertDuration: 0  //  original position after the drag
            });

        });

        var Calendar = FullCalendar.Calendar;
        var Draggable = FullCalendar.Draggable;

        var containerEl = document.getElementById('external-events-' + calendarNumber);

        var calendarEl = document.getElementById(calendarElement);

        new Draggable(containerEl, {
            itemSelector: '.fc-event',
            eventData: function (eventEl) {

                if (guardsShiftsFilterIsActive) {
                    alert("Clear filter before adding new events");
                    return null;
                }
                else {
                    return {
                        title: eventEl.innerText,
                        duration: '04:00',
                        id: 'new-event-dragged-temp-id'
                    };
                }
              
            }
        });


        var today = new moment(localTime);

        var tempCalendar = new FullCalendar.Calendar(calendarEl, {
            initialView: 'dayGridMonth',
            editable: true,
            businessHours: true,
            selectable: true,
            droppable: false,
            eventTextColor: '#212529',
            nowIndicator: false,
            weekends: true,
            displayEventEnd: true,
       //     timeFormat: 'h(:mm)t',
            height: 1200,
            allDaySlot: true,
      //      width: '100%',
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,listMonth timeGridWeek,listWeek timeGridDay,listDay'
            },
            drop: function (info) {
                setTimeout(function () {
                    var addedEvent = calendarHolder[calendarNumber].getEventById('new-event-dragged-temp-id');

                    var guardColorShift = getGuardColorShift(shiftsCalendarAllGuards, addedEvent.title);

                    addedEvent.setProp("color", guardColorShift);
                    addedEvent.setProp("id", uuidv4());

                }, 500);

            },
            dateClick: function (info) {
                // alert('clicked ' + info.dateStr);
            },
            //eventContent: function (arg) {
            //    let italicEl = document.createElement('i')

            //    //if (arg.event.extendedProps.isUrgent) {
            //    //    italicEl.innerHTML = 'urgent event'
            //    //} else {
            //    //    italicEl.innerHTML = 'normal event'
            //    //}

            //    italicEl.innerHTML = 'normal event'

            //    let arrayOfDomNodes = [italicEl]
            //    return { domNodes: arrayOfDomNodes }
            //},
            //eventContent: function (info) {
            //    var title = info.event.title;

            //    try {
            //        if (info.event.extendedProps.userNote != null) {
            //            title += " (" + info.event.extendedProps.userNote + ")"
            //        }

            //    } catch (e) {

            //    }
            //    return title;
            //},
            select: function (info) {


                if (calendarNumber == 1) {

                    var now = moment(info.startStr);
                    var end = moment(info.endStr);

                    var startString = "";
                    var endString = "";

                    if (dateFormat == "1") {
                        startString = now.format('MMMM d, YYYY h:mma');
                        endString = end.format('MMMM d, YYYY h:mma');
                    }
                    else {
                        startString = now.format('YYYY-MM-DD HH:mm');
                        endString = end.format('YYYY-MM-DD HH:mm');
                    }

                    $('#calendarSelectedStartTime').text(startString);
                    $('#calendarSelectedEndTime').text(endString);


                    var duration = moment.duration(end.diff(now));

                    //Get Days and subtract from duration
                    var days = Math.floor(duration.asDays());
                    duration.subtract(moment.duration(days, 'days'));

                    //Get hours and subtract from duration
                    var hours = duration.hours();
                    duration.subtract(moment.duration(hours, 'hours'));

                    //Get Minutes and subtract from duration
                    var minutes = duration.minutes();
                    duration.subtract(moment.duration(minutes, 'minutes'));

                    //Get seconds
                    var seconds = duration.seconds();

                    var ret = "";
                    if (days > 0) {
                        if (hours > 0) {
                            if (minutes > 0) {
                                var ret = days + (days == 1 ? " day " : " days ") + hours + "h " + minutes + "m";
                            }
                            else {
                                var ret = days + (days == 1 ? " day " : " days ") + hours + "h";
                            }

                        }
                        else {
                            if (minutes > 0) {
                                var ret = days + (days == 1 ? " day " : " days ") + minutes + "m";
                            }
                            else {
                                var ret = days + (days == 1 ? " day " : " days");
                            }

                        }

                    }
                    else {
                        if (minutes > 0) {
                            if (hours > 0) {
                                ret = hours + "h " + minutes + "m";
                            }
                            else {
                                ret = minutes + "m";
                            }

                        }
                        else {

                            ret = hours + "h";
                        }

                    }

                    $('#calendarSelectedTimeDif').text(ret);

                    shiftsCalendarLastSelectedStartTime = info.startStr;
                    shiftsCalendarLastSelectedEndTime = info.endStr;

                    shiftsCalendarIsWaitingForGuardSelection = true;

                }


            },
            unselect: function (info) {

                setTimeout(function () {

                    shiftsCalendarIsWaitingForGuardSelection = false;

                    $(".select-guard-for-event").css({
                        "border-width": "0px",
                    });


                }, 500);

            },
            eventDrop: function (event, delta) {

            },
            eventClick: function (info) {
              

                //Only activate for shift planning
                if (calendarNumber == 1) {

                    var eventIdRaw = info.event.id;

                    tooltipData = '<br>';
                    tooltipData += '<div class="cal-tooltip-div">';

                 
                    tooltipData += '<div class="cal-tooltip-div-inner-two">'
                    tooltipData += '<button type="button" onclick="event.stopPropagation(); removeEventFromCalendar(' + "'" + eventIdRaw + "'," + calendarNumber + ');" class="btn btn-danger">Remove</button>';
                    tooltipData += '</div>';

                    tooltipData += '</div>';
                    tooltipData += '<br>';

                    var eventEditPopup = tippy(info.jsEvent.target, {
                        interactive: true,
                        allowHTML: true,
                        zIndex: 99999,
                        popperOptions: { strategy: 'fixed' },
                        content: tooltipData,
                    });


                    eventEditPopup.show();

                    info.jsEvent.target.addEventListener("mouseleave", function () {


                        setTimeout(function () {
                            if (eventEditPopup != null) {
                                //console.log("eventEditPopup.state.isVisible: " + eventEditPopup.state.isVisible);
                                //console.log("eventEditPopup.state.isShown: " + eventEditPopup.state.isShown);
                                if (eventEditPopup.state.isVisible == false) {
                                    eventEditPopup.destroy();
                                }

                            }
                        }, 500);

                    });
                }

                //if (info.event.title == "Jessica Smith") {
                //    info.event.title = "Marc Anderson";
                //}

                //info.el.style.borderColor = 'red';
            },
            viewClassNames: function (arg) {
                //console.log('viewClassNames', arg.view.type);
            },
            viewDidMount: function (arg) {
               // console.log('viewDidMount', arg.view.type);
               // console.log(arg.view);
            },
            viewWillUnmount: function (arg) {
               // console.log('viewWillUnmount', arg.view.type);
            }

        });

        calendarHolder[calendarNumber] = tempCalendar;

        $('#calendarInitLoading' + calendarNumber).hide();

        setTimeout(function () {

            calendarHolder[calendarNumber].render();

        }, 2000);

    });



    return 1;
}

function rerenderCalendars() {

    for (var i = 0; i < 3; i++) {
        try {
            calendarHolder[i].render();
        } catch (e) {

        }
    }
}

function removeEventFromCalendar(eventId, calendarNumber) {

    if (guardsShiftsFilterIsActive) {
        alert("Clear filter before removing/changing shifts");
        return;
    }
    else {

        try {

            var eventToRemove = calendarHolder[calendarNumber].getEventById(eventId);

            if (eventToRemove != null) {
                eventToRemove.remove();
            }

        } catch (e) {
            console.log(e);
        }
    }
   
}

function setEventNoteFromCalendar(eventId, calendarNumber) {

    swal({
        title: "Shift note",
        text: "Write a note related to this shift:",
        type: "input",
        showCancelButton: true,
        closeOnConfirm: false,
        inputPlaceholder: "Note"
    }, function (inputValue) {
        if (inputValue === false) return false;
        if (inputValue === "") {
            // swal.showInputError("You need to write a!");
            return false
        }

        var eventToSetNote = calendarHolder[calendarNumber].getEventById(eventId);
        eventToSetNote.setExtendedProp("userNote", inputValue);

        swal("Note saved", "", "success");
    });
}



function selectGuardForEvent(calendarNumber, guardName, guardColor) {


    if (shiftsCalendarIsWaitingForGuardSelection) {
        var newEvent = {};


        newEvent['id'] = uuidv4();
        //newEvent['groupId'] = null;
        newEvent['allDay'] = false;
        newEvent['start'] = shiftsCalendarLastSelectedStartTime;
        newEvent['end'] = shiftsCalendarLastSelectedEndTime;
        newEvent['startStr'] = shiftsCalendarLastSelectedStartTime
        newEvent['endStr'] = shiftsCalendarLastSelectedEndTime;
        newEvent['title'] = guardName;
        newEvent['url'] = '';
        try {
            newEvent['color'] = guardColor;
        } catch (e) {

        }

        calendarHolder[calendarNumber].addEvent(newEvent);

        shiftsCalendarIsWaitingForGuardSelection = false;
        $(".select-guard-for-event").css({
            "border-width": "0px"
        });
    }
    else {
        alert("Please select time first");
    }


}

function clearCalendar(calendarNumber) {
    try {
        var calendarEventsToClear = calendarHolder[calendarNumber].getEvents();

        if (calendarEventsToClear != null) {
            var calendarEventsToClearCount = calendarEventsToClear.length;
            for (var i = 0; i < calendarEventsToClearCount; i++) {

                if (calendarEventsToClear[i] != null) {
                    calendarEventsToClear[i].remove();
                }
            }
        }
    }
    catch (e) {

    }
}

function PopulateSiteCalendar(calendarNumber, calendarEventDtos, guards) {

    shiftsCalendarAllGuards = guards;

    try {
        clearCalendar(calendarNumber);
    }
    catch (e) {

    }

    var rawCalendarEvents = MapCalendarEvents(calendarEventDtos, 0);

    console.log(rawCalendarEvents);

    if (rawCalendarEvents != null) {
        var rawCalendarEventsCount = rawCalendarEvents.length;


        for (var j = 0; j < rawCalendarEventsCount; j++) {

            var guardName = rawCalendarEvents[j].title;

            rawCalendarEvents[j].color = getGuardColorShift(guards, guardName);

        }


        var rawEventCount = rawCalendarEvents.length;

        for (var i = 0; i < rawEventCount; i++) {
            calendarHolder[calendarNumber].addEvent(rawCalendarEvents[i]);
        }
    }


    return 1;

}

function getGuardColorShift(guards, guardName) {

    var guardsCount = guards.length;

    for (var k = 0; k < guardsCount; k++) {
        try {
            //if (guardName.indexOf(guards[k].guardName) >= 0) {
            if (guards[k].guardName.indexOf(guardName) >= 0) {

                return guards[k].guardColorShift;
            }
        } catch (e) {

        }
    }

    return '#A5C4E2';
}

function removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
}

function SaveShiftsEvents(calendarNumber) {

    var calendarEvents = calendarHolder[calendarNumber].getEvents();

    console.log("calendarEvents");
    console.log(calendarEvents);

    calendarEvents = removeDuplicates(calendarEvents, "id");

    var mappedEvents = MapCalendarEvents(calendarEvents, 1);

    return mappedEvents;
}

function MapCalendarEvents(events, toDto) {

    var calendarEventDtos = [];

    if (events == null) {
        return null;
    }

    var eventsCount = events.length;

    for (var i = 0; i < eventsCount; i++) {

        var calendarEventDto = {};

        var currentEventIteration = events[i];

        if (toDto == 0) {
            calendarEventDto['id'] = currentEventIteration['calendarEventId'];
            calendarEventDto['groupId'] = currentEventIteration['calendarEventGroupId'];
            calendarEventDto['allDay'] = currentEventIteration['calendarEventAllDay'];

            if (currentEventIteration['calendarEventDaysOfWeek'] != null) {
                calendarEventDto['daysOfWeek'] = currentEventIteration['calendarEventDaysOfWeek'];
            }

            calendarEventDto['start'] = currentEventIteration['calendarEventStartTime'];

            if (currentEventIteration['calendarEventDaysOfWeek'] != null) {

                if (currentEventIteration['calendarEventStartTimeOnly'] != "00:00:00" || currentEventIteration['calendarEventDaysOfWeek'].length != 0) {
                    calendarEventDto['startTime'] = currentEventIteration['calendarEventStartTimeOnly'];
                }

                if (calendarEventDto['startTime'] == "24:00:00" || calendarEventDto['startTime'] == "24:00") {
                    calendarEventDto['startTime'] = "00:00:00";
                }

            }
          


            if (currentEventIteration['calendarEventStartRecur'] != null) {
                calendarEventDto['startRecur'] = currentEventIteration['calendarEventStartRecur'];
            }



            calendarEventDto['end'] = currentEventIteration['calendarEventEndTime'];

            if (currentEventIteration['calendarEventDaysOfWeek'] != null) {

                if (currentEventIteration['calendarEventEndTimeOnly'] != "00:00:00" || currentEventIteration['calendarEventDaysOfWeek'].length != 0) {
                    calendarEventDto['endTime'] = currentEventIteration['calendarEventEndTimeOnly'];
                }

                if (calendarEventDto['endTime'] == "00:00:00" || calendarEventDto['endTime'] == "00:00") {
                    calendarEventDto['endTime'] = "24:00:00";
                }
            }

            if (currentEventIteration['calendarEventEndRecur'] != null) {
                calendarEventDto['endRecur'] = currentEventIteration['calendarEventEndRecur'];
            }

            calendarEventDto['startStr'] = currentEventIteration['calendarEventStartFormatted'];
            calendarEventDto['endStr'] = currentEventIteration['calendarEventEndFormatted'];
            calendarEventDto['title'] = currentEventIteration['calendarEventTitle'];
            calendarEventDto['url'] = currentEventIteration['calendarEventUrl'];

            var d2 = new Date(calendarEventDto['end']);
            var d1 = new Date(calendarEventDto['start']);

            if (sameDate(d2, d1)) {
            }
            else {
                var timeDiffInMs = msToHMS(d2 - d1);
                calendarEventDto['duration'] = timeDiffInMs;
            }
            
            try {
                calendarEventDto['color'] = currentEventIteration['calendarEventColor'];

            } catch (e) {
            }

            try {
                calendarEventDto['extendedProps'] = currentEventIteration['calendarEventExtendedProps'];

            } catch (e) {

            }

        }
        else {
            calendarEventDto['CalendarEventId'] = (currentEventIteration.id == "" || currentEventIteration.id == "0") ? uuidv4() : currentEventIteration.id;
            calendarEventDto['CalendarEventGroupId'] = currentEventIteration.groupId;
            calendarEventDto['CalendarEventAllDay'] = currentEventIteration.allDay;
            calendarEventDto['CalendarEventDuration'] = currentEventIteration.duration;
            calendarEventDto['CalendarEventStartTime'] = currentEventIteration.start;
            calendarEventDto['CalendarEventEndTime'] = currentEventIteration.end;
            calendarEventDto['CalendarEventStartFormatted'] = currentEventIteration.startStr;
            calendarEventDto['CalendarEventEndFormatted'] = currentEventIteration.endStr;
            calendarEventDto['CalendarEventTitle'] = currentEventIteration.title;
            calendarEventDto['CalendarEventUrl'] = currentEventIteration.url;
            
            try {
                calendarEventDto['calendarEventDaysOfWeek'] = currentEventIteration._def.recurringDef.typeData.daysOfWeek;
            } catch (e) {

            }

            try {
                var dtemp = new Date(currentEventIteration.start);
                var datetext = dtemp.toTimeString();
                datetext = datetext.split(' ')[0];

                calendarEventDto['calendarEventStartTimeOnly'] = datetext;

            } catch (e) {
                calendarEventDto['calendarEventStartTimeOnly'] = "00:00:00";
            }

            try {
                calendarEventDto['calendarEventStartRecur'] = currentEventIteration._def.recurringDef.typeData.startRecur;
            } catch (e) {

            }

            try {
                var dtemp = new Date(currentEventIteration.end);
                var datetext = dtemp.toTimeString();
                datetext = datetext.split(' ')[0];

                calendarEventDto['calendarEventEndTimeOnly'] = datetext;

            } catch (e) {

            }


            try {
                calendarEventDto['calendarEventEndRecur'] = currentEventIteration._def.recurringDef.typeData.endRecur;
            } catch (e) {

            }

            try {

                calendarEventDto['CalendarEventColor'] = currentEventIteration.color;


            } catch (e) {

            }

            try {
                calendarEventDto['CalendarEventExtendedProps'] = currentEventIteration.extendedProps;

            } catch (e) {

            }
        }
        console.log("resulted in");
        console.log(calendarEventDto);
        calendarEventDtos.push(calendarEventDto);

    }

    console.log("done mapping");


    return calendarEventDtos;

}

function ExportCalendar() {

    try {

        var element = document.getElementById('shiftsplannerholder');
        var name = "shiftsplannedexport";
        var orientation = 'landscape';
        var customSizes = true;

        var html2canvas = customSizes ? { logging: true, allowTaint: true, async: true, windowHeight: $(element).height() * 1, windowWidth: $(element).width() * 0.75 } : { logging: true, allowTaint: true, scale: 2.5 };
        var jsPDF = customSizes ? { unit: 'pt', format: [$(element).height() * 1, $(element).width() * 0.75], orientation: orientation } : { format: 'a4', orientation: orientation };
        var opt = {
            margin: 2,
            filename: name,
            image: {
                type: 'jpeg',
                quality: 0.98
            },
            html2canvas: html2canvas,
            jsPDF: jsPDF
        };
        return html2pdf().set(opt).from(element).save();
    } catch (e) {
        alert(e);
        return null;
    }
}


function showPlannerNotificationToast(message) {
    var x = document.getElementById("snackbarPlanner");
    x.className = "show";
    x.innerHTML = message;
    setTimeout(function () { x.className = x.className.replace("show", ""); x.innerHTML = ""; }, 3000);
}

function renderCalendarForce(calendarNumber) {
    setTimeout(function () {

        //$('#calendarInitLoading1').hide();
        console.log("calendarHolder");
        console.log(calendarHolder);
        calendarHolder[calendarNumber].render();
    }, 20);
}


//////////////////////////////////////////////////

function eventModalShow(eventId, calendarNumber, arg) {

    console.log("eventModalShow:" + calendarNumber);

    if (calendarNumber == 1) {
        document.getElementById('eventCreateModalTitleHeader').innerHTML = 'Plan Shift';
    }
    else if (calendarNumber == 3) {
        document.getElementById('eventCreateModalTitleHeader').innerHTML = 'New Maintenance Task';
    }
    else if (calendarNumber == 2) {
        document.getElementById('eventCreateModalTitleHeader').innerHTML = 'New Happening';
    }


    eventCreateCurrentlySelectedTab = calendarNumber;
    $('#editModal').modal();
}

var plannerIsUsDateFormat = true;

function setDateFormatForPlanner(dateFormat) {
    if (dateFormat == 0) {
        plannerIsUsDateFormat = false;
    }
}

function eventModalCreateDone() {

    var reoccuringMode = eventCreateCurrentlySelectedMode == 0;

    var calendarNumber = eventCreateCurrentlySelectedTab;

    console.log('reoccuringMode');
    console.log(reoccuringMode);

    var eventGuid = uuidv4();


    var calendarEventDto = {};

    calendarEventDto['id'] = eventGuid;

    var grNumber = Math.floor(Math.random() * 10000000);
    calendarEventDto['groupId'] = grNumber;


    var reoccuringDaysHelpTextDays = [];
    var reoccuringHelpText = "";

    if (reoccuringMode) {

        var startTime = document.getElementById('start_time').value;
        var endTime = document.getElementById('finish_time').value;

        console.log("startTime");
        console.log(startTime);
       
        console.log("endTime");
        console.log(endTime);

        if (startTime == "24:00") {
            startTime = "00:00";
        }

        if (endTime == "00:00") {
            endTime = "24:00";
        }

        var startDateObject = new Date();
        var startTimeStr = n2(startDateObject.getHours()) + ":" + n2(startDateObject.getMinutes());
        var startDateStr = startDateObject.getFullYear() + "-" + n2(startDateObject.getMonth() + 1) + "-" + n2(startDateObject.getDate())

        var anytimeDuringTheDay = document.getElementById('eventCreateReoccuringAnytimeDuringTheDaySwitch').checked;

        calendarEventDto['allDay'] = anytimeDuringTheDay;

        if (!anytimeDuringTheDay) {
            calendarEventDto['startTime'] = startTime;
            calendarEventDto['endTime'] = endTime;
        }
        else {
            calendarEventDto['startTime'] = null;
            calendarEventDto['endTime'] = null;
        }

        calendarEventDto['start'] = null;
        calendarEventDto['end'] = null;


        calendarEventDto['startRecur'] = startDateStr;

        var weekdayArray = [];

        if (document.getElementById('weekday-sun').checked) {
            weekdayArray.push(0);
            reoccuringDaysHelpTextDays.push('Sunday');
        }
        if (document.getElementById('weekday-mon').checked) {
            weekdayArray.push(1);
            reoccuringDaysHelpTextDays.push('Monday');
        }
        if (document.getElementById('weekday-tue').checked) {
            weekdayArray.push(2);
            reoccuringDaysHelpTextDays.push('Tuesday');
        }
        if (document.getElementById('weekday-wed').checked) {
            weekdayArray.push(3);
            reoccuringDaysHelpTextDays.push('Wednesday');
        }
        if (document.getElementById('weekday-thu').checked) {
            weekdayArray.push(4);
            reoccuringDaysHelpTextDays.push('Thursday');
        }
        if (document.getElementById('weekday-fri').checked) {
            weekdayArray.push(5);
            reoccuringDaysHelpTextDays.push('Friday');
        }
        if (document.getElementById('weekday-sat').checked) {
            weekdayArray.push(6);
            reoccuringDaysHelpTextDays.push('Saturday');
        }

        //Must select at least one week day
        if (weekdayArray == null || weekdayArray.length == 0 || weekdayArray.length > 7) {
            alert("Select at least one weekday");
            return;
        }

        if ((startTime == null || startTime == "") && !anytimeDuringTheDay) {
            return;
        }

        if ((endTime == null || endTime == "") && !anytimeDuringTheDay) {
            return;
        }

        var recurringEndTimeDate = document.getElementById('recurring_finish_time_date').value;


        if ((recurringEndTimeDate == null || recurringEndTimeDate == "")) {
            alert("Enter recurring end time");
            return;
        }

        var endRecurHelpText = '';

        try {
            calendarEventDto['endRecur'] = new Date(recurringEndTimeDate);


            if (plannerIsUsDateFormat) {
                try {
                    endRecurHelpText = " ends on " + moment(recurringEndTimeDate).format('MMM Do YYYY');
                } catch (e) {

                }
            }
            else {

                try {
                    endRecurHelpText = " ends on " + moment(recurringEndTimeDate).format('YYYY-MM-DD');
                } catch (e) {

                }
            }
        } catch (e) {

        }

        var startTimeOnlyFormatted = startTime;
        var endTimeOnlyFormatted = endTime;


        if (plannerIsUsDateFormat) {

            var endTimeO = null;
            var startTimeO = null;
            try {
                startTimeO = moment(startTime, 'HH:mm');
                startTimeOnlyFormatted = startTimeO.format('h:mm a').toUpperCase();
            } catch (e) {

            }

            try {
                endTimeO = moment(endTime, 'HH:mm');
                endTimeOnlyFormatted = endTimeO.format('h:mm a').toUpperCase();
            } catch (e) {

            }

            if (endTimeO == null || startTimeO == null) {
                return;
            }

            if (endTimeO <= startTimeO) {
                var duration = moment.duration(endTimeO.diff(startTimeO));
                var durstring = moment.utc(duration.as('milliseconds')).format('HH:mm:ss');
                calendarEventDto['duration'] = durstring;
            }

        }
        reoccuringHelpText = "every " + reoccuringDaysHelpTextDays.join(", ");

        if (!anytimeDuringTheDay) {
            reoccuringHelpText += " " + startTimeOnlyFormatted + " - " + endTimeOnlyFormatted;
        }


        reoccuringHelpText += endRecurHelpText;

        calendarEventDto['daysOfWeek'] = weekdayArray;

    }
    else {

        var startTimeDateRaw = document.getElementById('start_time_date').value;
        var endTimeDateRaw = document.getElementById('finish_time_date').value;


        var startTimeDate = new Date(Date.parse(startTimeDateRaw));
        var endTimeDate = new Date(Date.parse(endTimeDateRaw));


        if (startTimeDate == null || startTimeDate == "") {
            return;
        }

        if (endTimeDate == null || endTimeDate == "") {
            return;
        }


        var startDateObject = new Date(startTimeDate);
        var startTimeStr = n2(startDateObject.getHours()) + ":" + n2(startDateObject.getMinutes());
        var startDateStr = startDateObject.getFullYear() + "-" + n2(startDateObject.getMonth() + 1) + "-" + n2(startDateObject.getDate())

        var endDateObject = new Date(endTimeDate);
        var endTimeStr = n2(endDateObject.getHours()) + ":" + n2(endDateObject.getMinutes());

        if (endDateObject <= startDateObject) {
      
            alert("Start date must be before end date");
            return;
        }

        calendarEventDto['start'] = startDateObject;

        calendarEventDto['end'] = endDateObject;

        var startTimeDateFormatted = startTimeDate;
        var endTimeDateFormatted = endTimeDate;

        //We use formatted timestamps due to issues with timezone offsets in serialization
        if (plannerIsUsDateFormat) {
            try {
                startTimeDateFormatted = moment(startTimeDate).format('MMM Do YYYY, h:mm A');
            } catch (e) {

            }

            try {
                endTimeDateFormatted = moment(endTimeDate).format('MMM Do YYYY, h:mm A');
            } catch (e) {

            }

        }
        else {

            try {
                startTimeDateFormatted = moment(startTimeDate).format('YYYY-MM-DD, HH:mm');
            } catch (e) {

            }

            try {
                endTimeDateFormatted = moment(endTimeDate).format('YYYY-MM-DD, HH:mm');
            } catch (e) {

            }

        }
        if (eventCreateCurrentlySelectedMode == 2) {
            reoccuringHelpText = "once every shift";
        }
        else {
            reoccuringHelpText = "once " + startTimeDateFormatted + " - " + endTimeDateFormatted;
        }
    }

    var title = document.getElementById('event_modal_title').value;
    var content = document.getElementById('event_modal_content').value;
    var helpInfoInstructions = document.getElementById('event_modal_helpinfo').value;

    if (calendarNumber == 1) {
        title = $("#eventCreateSelectGuard option:selected").text();
    }

    if (!title) {
        alert("Enter a title");
        return;
    }

    calendarEventDto['color'] = '#1B6EC2';

    try {
        if (calendarNumber == 1) {
            calendarEventDto['color'] = getGuardColorShift(shiftsCalendarAllGuards, title);
        }

    } catch (e) {

    }

    try {
        //use filler text box as title
        if (eventCreateCurrentlyRegisteredOrFillerGuardSelectedMode == 1) {
            title = document.getElementById('plannedShiftFillerInput').value;
        }
    } catch (e) {

    }

    calendarEventDto['title'] = title;
    calendarEventDto['url'] = '';

    calendarHolder[calendarNumber].addEvent(calendarEventDto);

    var eventInCalendar = calendarHolder[calendarNumber].getEventById(calendarEventDto['id']);

    DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnEventCreatedFromModal', calendarEventDto['id'], 1234, title, content, !reoccuringMode, reoccuringHelpText, helpInfoInstructions, "helptextimagestub", calendarNumber, eventCreateCurrentlySelectedMode);

    $(function () {
        $('#editModal').modal('toggle');

        setTimeout(function () {
            $('#eventCreateReoccuringModeRadioButton').prop('checked', true);
            $('#eventCreateReoccuringOneTimeModeRadioButton').prop('checked', false);

            eventModalCreateSelectReoccuring(0);

            $('#eventCreateReoccuringAnytimeDuringTheDaySwitch').prop('checked', false);
            $('#eventReoccuringTimeSelectDiv').show();

            document.getElementById('start_time').value = '';
            document.getElementById('finish_time').value = '';

            document.getElementById('start_time_date').value = '';
            document.getElementById('finish_time_date').value = '';

            document.getElementById('recurring_finish_time_date').value = '';

            document.getElementById('event_modal_title').value = '';
            document.getElementById('event_modal_content').value = '';
            document.getElementById('event_modal_helpinfo').value = '';

            document.getElementById('weekday-mon').checked = false;
            document.getElementById('weekday-tue').checked = false;
            document.getElementById('weekday-wed').checked = false;
            document.getElementById('weekday-thu').checked = false;
            document.getElementById('weekday-fri').checked = false;
            document.getElementById('weekday-sat').checked = false;
            document.getElementById('weekday-sun').checked = false;
        }, 1000);


    });
}

function eventModalCreateSelectReoccuring(mode) {

    eventCreateCurrentlySelectedMode = mode;

    if (mode == 0) {
        $('#eventCreateOneTimeMode').hide();
        $('#eventCreateEveryNewShiftMode').hide();
        $('#eventCreateReoccuringMode').show();

    } else if (mode == 1) {
        $('#eventCreateReoccuringMode').hide();
        $('#eventCreateEveryNewShiftMode').hide();
        $('#eventCreateOneTimeMode').show();
    }
    else {
        $('#eventCreateReoccuringMode').hide();
        $('#eventCreateOneTimeMode').hide();
        $('#eventCreateEveryNewShiftMode').show();
    }


}

function eventModalSelectRegisteredOrFillerMode(mode) {

    eventCreateCurrentlyRegisteredOrFillerGuardSelectedMode = mode;

    if (mode == 0) {
        $('#eventCreateFillerModeDiv').hide();
        $('#eventCreateRegisteredGuardModeDiv').show();

    } else {
        $('#eventCreateRegisteredGuardModeDiv').hide();
        $('#eventCreateFillerModeDiv').show();
    }


}

function eventCreateAnytimeDuringTheDayChange(checkbox) {

    if (checkbox.checked == true) {
        $('#eventReoccuringTimeSelectDiv').hide();
    } else {
        $('#eventReoccuringTimeSelectDiv').show();
    }

}

function filterShiftsCalendar(guardName) {

}

function deleteTask(calendarNumber, maintenanceTaskId, calendarEventId) {

    swal({
        title: "Are you sure?",
        text: " ",
        showCancelButton: true,
        confirmButtonText: "Yes, remove.",
        cancelButtonText: "No",
        closeOnConfirm: true
    },
        function () {

            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnEventDeletedByUser', calendarNumber, maintenanceTaskId, calendarEventId);
        });
}


function openEventModalUpdate(calendarNumber, dataObject) {

    if (calendarNumber == 3) {
        try {
            document.getElementById('eventCreateModalTitleHeaderEdit').innerHTML = 'Edit Maintenance Task';
            document.getElementById('event_modal_title_edit').value = dataObject.maintenanceTaskTitle;
            document.getElementById('event_modal_content_edit').value = dataObject.maintenanceTaskDescription;
            document.getElementById('event_modal_helpinfo_edit').value = dataObject.maintenanceTaskDescriptionHelpInfo;
            document.getElementById('event_modal_task_edit_id').innerHTML = dataObject.maintenanceTaskId;
            document.getElementById('event_modal_task_edit_calendar_number').innerHTML = calendarNumber;

           
        } catch (e) {

        }
    }
    else if (calendarNumber == 2) {
        try {
            document.getElementById('eventCreateModalTitleHeaderEdit').innerHTML = 'Edit Happening';
            document.getElementById('event_modal_title_edit').value = dataObject.happeningTitle;
            document.getElementById('event_modal_content_edit').value = dataObject.happeningDescription;
            document.getElementById('event_modal_helpinfo_edit').value = dataObject.happeningDescriptionHelpInfo;
            document.getElementById('event_modal_task_edit_id').innerHTML = dataObject.happeningId;
            document.getElementById('event_modal_task_edit_calendar_number').innerHTML = calendarNumber;
        } catch (e) {

        }
    }

    $('#editModalEdit').modal();
}



function eventModalUpdateDone() {

    try {
        var taskId = parseInt(document.getElementById('event_modal_task_edit_id').innerHTML);
        var calendarNumber = parseInt(document.getElementById('event_modal_task_edit_calendar_number').innerHTML);
        var title = document.getElementById('event_modal_title_edit').value;
        var description = document.getElementById('event_modal_content_edit').value;
        var helpInfo = document.getElementById('event_modal_helpinfo_edit').value;

        if (!title) {
            return;
        }

        DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnEventEditedFromModal', calendarNumber, taskId, title, description, helpInfo);

        $(function () {
            $('#editModalEdit').modal('toggle');

            setTimeout(function () {

            }, 500);


        });
    } catch (e) {
        alert(e);
    }
}

function applyGuardShiftsFilter(calendarNumber, listOfGuardNames) {

    var eventsToCheck = [];

    if (listOfGuardNames == null || listOfGuardNames.length == 0) {
        return;
    }


    if (!guardsShiftsFilterIsActive) {
        guardsShiftsCacheForFilter = calendarHolder[calendarNumber].getEvents();
        eventsToCheck = guardsShiftsCacheForFilter;
    }
    else {
        eventsToCheck = guardsShiftsCacheForFilter;
    }

    clearCalendar(calendarNumber);

    var filteredEvents = [];

    if (eventsToCheck != null) {
        var eventsToCheckCount = 0;

        eventsToCheckCount = eventsToCheck.length;

        for (var i = 0; i < eventsToCheckCount; i++) {
            var shiftGuardName = eventsToCheck[i].title;

            if (listOfGuardNames.indexOf(shiftGuardName) >= 0) {
                filteredEvents.push(eventsToCheck[i]);

                calendarHolder[calendarNumber].addEvent(eventsToCheck[i]);
            }
        }
    }

    guardsShiftsFilterIsActive = true;
}

function restoreGuardShiftsFilter(calendarNumber, arg) {

    try {

        if (guardsShiftsFilterIsActive) {

            clearCalendar(calendarNumber);

            var eventsToRestore = guardsShiftsCacheForFilter;

            if (eventsToRestore != null) {
                var eventsToRestoreCount = 0;

                eventsToRestoreCount = eventsToRestore.length;

                for (var i = 0; i < eventsToRestoreCount; i++) {

                    calendarHolder[calendarNumber].addEvent(eventsToRestore[i]);

                }
            }

            guardsShiftsCacheForFilter = null;
        }
        else {
        }

    } catch (e) {

    }

    guardsShiftsFilterIsActive = false;

}

function createPlannerPageTooltip(el, text) {
    setTimeout(function () {
        tippy(el, {
            content: '<span>' + text + '</span>',
            allowHTML: true
        });
    }, 1500);

}

function sameDate(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate();
}

function msToHMS(ms) {
    let seconds = ms / 1000;
    const hours = parseInt(seconds / 3600);
    seconds = seconds % 3600;
    const minutes = parseInt(seconds / 60);
    seconds = seconds % 60;
    return (n2(hours) + ":" + n2(minutes) + ":" + n2(seconds));
}